'use client';

import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import { Button } from '@components/common/Forms/Button/Button';
import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common/Anchor/LinkStyled';
import { ArrowLongLeftIcon, ArrowLongRightIcon } from '@heroicons/react/16/solid';


/**
 * @description Error buttons props.
 */
interface ErrorButtonsProps {
  code?: number;
}


/**
 * @description Error buttons component.
 * - `code`: *number* - The error code.
 * - `className`: *string* - Optional class name to apply to the buttons.
 */
export const ErrorButtons = (props: ErrorButtonsProps) => {
  // Destructure props
  const { code } = props;

  // Translation
  const { t } = useTranslation('common');

  // Router
  const { router } = useExtendedRouter();

  // Helpers
  const goBack = () => router.back();

  // Render component
  // ****************************
  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {/* Back button */}
      <Button
        rounding="full"
        size="sm"
        color="light"
        styling="outline"
        onClick={goBack}
        className="gap-1.5 !py-2 !pr-6"
      >
        <ArrowLongLeftIcon className="size-5" />
        {t('global.action.back')}
      </Button>

      {/* Go to log-in, display only for not-auth error */
        String(code) === '401' && (
          <LinkStyled
            rounding="full"
            size="sm"
            styling="outline"
            color="light"
            href="/login"
            className="gap-1.5 !py-2 !pl-6"
          >
            {t('menu.sign_in-register')}
            <ArrowLongRightIcon className="size-5" />
          </LinkStyled>
        )
      }
    </div>
  );
};
